import Feed from 'containers/feed';
import { useUrlQuery } from 'hooks/useUrlQuery';
import { useLocation } from 'react-router-dom';

export const RecommendStylePage = () => {
    const query = useUrlQuery();
    const location: any = useLocation();
    return (
        <Feed
            stylistName={query.get('stylistName') as string}
            title={location?.state?.title || ''}
            entityActiveId={location?.state?.taffiId}
            sourceProductUrl={location?.state?.sourceProductURL}
        />
    );
};
